
export default {
  print: {
    print: 'Imprimir',
    segment: 'Segmento',
    preparingPrinting: 'Preparando impressão',
    readyToPrint: 'Pronta para imprimir'
  }
}
